<form class="form-body pb-0" [formGroup]="samlSettingForm" (ngSubmit)="onSubmit()">
    <div class="grid">
        <div class="col-12">
            <div class="form-group flex flex-column w-full">
                <label for="entity_id">Entity id <span class="required">*</span></label>
                <input id="entity_id" pInputText formControlName="entity_id" />
                <div *ngIf="samlSettingForm.get('entity_id')?.invalid && samlSettingForm.get('entity_id')?.touched">
                    <small *ngIf="samlSettingForm.get('entity_id')?.errors?.['required']" class="p-error">Entity id is required.</small>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group flex flex-column w-full">
                <label for="login_url">Login url <span class="required">*</span></label>
                <input id="login_url" pInputText formControlName="login_url" />
                <div *ngIf="samlSettingForm.get('login_url')?.invalid && samlSettingForm.get('login_url')?.touched">
                    <small *ngIf="samlSettingForm.get('login_url')?.errors?.['required']" class="p-error">Login url is required.</small>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group flex flex-column w-full">
                <label for="logout_url">Logout url <span class="required">*</span></label>
                <input id="logout_url" pInputText formControlName="logout_url" type="logout_url" />
                <div *ngIf="samlSettingForm.get('logout_url')?.invalid && samlSettingForm.get('logout_url')?.touched">
                    <small *ngIf="samlSettingForm.get('logout_url')?.errors?.['required']" class="p-error">Login url is required.</small>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group flex flex-column w-full">
                <label for="fingerprint">Fingerprint <span class="required">*</span></label>
                <input id="fingerprint" pInputText formControlName="fingerprint" />
                <div *ngIf="samlSettingForm.get('fingerprint')?.invalid && samlSettingForm.get('fingerprint')?.touched">
                    <small *ngIf="samlSettingForm.get('fingerprint')?.errors?.['required']" class="p-error">Fingerprint is required.</small>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group flex flex-column w-full">
                <label for="certificate">Certificate <span class="required">*</span></label>
                <textarea id="message" pInputTextarea formControlName="certificate"></textarea>
                <div *ngIf="samlSettingForm.get('certificate')?.invalid && samlSettingForm.get('certificate')?.touched">
                    <small *ngIf="samlSettingForm.get('certificate')?.errors?.['required']" class="p-error">Certificate is required.</small>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="form-group flex flex-column w-full">
                <div class="form-group flex flex-column w-full">
                <label for="is_enabled">Enable SSO</label>
                <label class="switch">
                    <input type="checkbox" formControlName="is_enabled">
                    <span class="slider round"></span>
                </label>
            </div>
            </div>
        </div>
    </div>
  </form>
  <div class="form-action flex justify-content-center">
    <p-button
        label="Cancel"
        [outlined]="true"
        severity="secondary"
        (onClick)="onCancel()"
    ></p-button>
    <p-button
        label="Update"
        type="submit"
        icon="pi pi-check"
        styleClass="brown-btn"
        iconPos="left"
        severity="primary"
        (click)="onSubmit()"
        [style]="{ 'margin-left': '.8em' }"
        [disabled]="!samlSettingForm.valid"
    ></p-button>
</div>